import MainLayout from "@/components/layout/applicant/MainLayout.vue";
export default {
    name: "policy",
    components: {
        MainLayout
    }
};
